import React, { useState } from 'react'

import {
    UpdateMemberCredentialPromptFormComponent,
    UpdateMemberCredentialPromptFormFieldName,
    UpdateMemberEmailFormComponent,
    UpdateMemberEmailFormFieldComponent,
    UpdateMemberEmailFormFieldName,
    UpdateMemberPasswordFormComponent,
    UpdateMemberPasswordFormFieldComponent,
    UpdateMemberPasswordFormFieldName,
    Modal
} from '@vista-digital/occ-ui'

import { cmsDataService } from '../../../services'
import { resetCaptcha } from '../../../utilities/recaptcha'

import './account-details.scss'

export const AccountDetailsComponent: React.FC = () => {

    const [showEmailModal, setShowEmailModal] = useState<boolean>()
    const [showPasswordModal, setShowPasswordModal] = useState<boolean>()

    const handleEmailChangeClick = () => {
        setShowEmailModal(true)
    }

    const handlePasswordChangeClick = () => {
        setShowPasswordModal(true)
    }

    const handleCloseModal = () => {
        setShowEmailModal(false)
        setShowPasswordModal(false)
    }

    const formEvents = {
        onAfterSuccessfulSubmit: () => handleCloseModal(),
        onCancelButtonClicked: () => handleCloseModal(),
        onAfterFailedSubmit: () => resetCaptcha()
    }

    const emailFormConfig = {
        validation: {
            captcha: {
                required: !!cmsDataService.captchaEnabled()
            }
        }
    }

    const passwordFormConfig = {
        validation: {
            captcha: {
                required: !!cmsDataService.captchaEnabled()
            }
        }
    }

    return (
        <>
            <UpdateMemberCredentialPromptFormComponent
                fieldToUpdate={UpdateMemberCredentialPromptFormFieldName.Email}
                events={{
                    onActionButtonClicked: handleEmailChangeClick
                }}
            />
            <UpdateMemberCredentialPromptFormComponent
                fieldToUpdate={UpdateMemberCredentialPromptFormFieldName.Password}
                events={{
                    onActionButtonClicked: handlePasswordChangeClick
                }}
            />
            <Modal show={showEmailModal} onClose={handleCloseModal} className="account-details-modal">
                <UpdateMemberEmailFormComponent config={emailFormConfig} events={formEvents}>
                    <UpdateMemberEmailFormFieldComponent name={UpdateMemberEmailFormFieldName.Email} />
                    <UpdateMemberEmailFormFieldComponent name={UpdateMemberEmailFormFieldName.CurrentPassword} />
                    {cmsDataService.captchaEnabled() && (
                        <UpdateMemberEmailFormFieldComponent name={UpdateMemberEmailFormFieldName.Captcha} />
                    )}
                </UpdateMemberEmailFormComponent>
            </Modal>
            <Modal show={showPasswordModal} onClose={handleCloseModal} className="account-details-modal">
                <UpdateMemberPasswordFormComponent config={passwordFormConfig} events={formEvents}>
                    <UpdateMemberPasswordFormFieldComponent name={UpdateMemberPasswordFormFieldName.Password} />
                    <UpdateMemberPasswordFormFieldComponent name={UpdateMemberPasswordFormFieldName.CurrentPassword} />
                    {cmsDataService.captchaEnabled() && (
                        <UpdateMemberPasswordFormFieldComponent name={UpdateMemberPasswordFormFieldName.Captcha} />
                    )}
                </UpdateMemberPasswordFormComponent>
            </Modal>
        </>
    )
}

export default AccountDetailsComponent